/**
 * Espelho LOCAL das travas de frequência do NPS.
 *
 * A regra de verdade é do SERVIDOR (30 dias entre pesquisas, 90 no mesmo
 * módulo, 15 após dispensa). Isto aqui existe só para evitar uma chamada de
 * elegibilidade a cada navegação: se a trava morasse no navegador, a mesma
 * pessoa responderia de novo no notebook de casa e a amostra penderia para
 * quem usa mais dispositivos.
 *
 * Consequência prática: quando o localStorage some (aba anônima, limpeza), o
 * pior que acontece é uma chamada a mais — o servidor barra do mesmo jeito.
 *
 * A chave é carimbada por profissional: máquina compartilhada não pode fazer
 * a trava de um esconder a pesquisa do outro.
 */
const PREFIXO = 'aawz_nps'

const DIAS_ENTRE_PESQUISAS = 30
const DIAS_MESMO_MODULO = 90
// Dispensa NÃO é resposta. Era 60 dias no módulo + 30 em tudo — e em produção
// (11–15/09/2026) 81 de 82 pessoas fecharam o card por reflexo, no meio do
// fechamento de comissão: um mês inteiro sem chance de perguntar de novo, no
// momento certo. Quinze dias é "agora não", que é o que o clique no X significa.
const DIAS_APOS_DISPENSA = 15

const UM_DIA_EM_MS = 86400000

function chave(idProfissional, sufixo) {
  return PREFIXO + ':' + idProfissional + ':' + sufixo
}

function marcar(idProfissional, sufixo, dias) {
  try {
    globalThis.localStorage.setItem(
      chave(idProfissional, sufixo),
      String(Date.now() + dias * UM_DIA_EM_MS)
    )
  } catch (error_) {
    // localStorage indisponível (aba anônima, cota cheia): seguir sem espelho.
    // O servidor continua sendo a trava real, então isto não é falha de produto.
    // eslint-disable-next-line no-console
    console.warn(
      '[nps] localStorage indisponível ao marcar:',
      error_ && error_.message
    )
  }
}

function bloqueado(idProfissional, sufixo) {
  try {
    const ate = globalThis.localStorage.getItem(chave(idProfissional, sufixo))
    return !!ate && Number(ate) > Date.now()
  } catch (error_) {
    // Sem espelho local a decisão fica com o servidor, que é a trava real —
    // por isso "não bloqueado" é a resposta segura aqui.
    // eslint-disable-next-line no-console
    console.warn(
      '[nps] localStorage indisponível ao ler:',
      error_ && error_.message
    )
    return false
  }
}

export function podePerguntar(idProfissional, modulo) {
  if (!idProfissional || !modulo) return false
  return (
    !bloqueado(idProfissional, 'geral') &&
    !bloqueado(idProfissional, 'adiado') &&
    !bloqueado(idProfissional, 'resp:' + modulo) &&
    !bloqueado(idProfissional, 'dispensa:' + modulo)
  )
}

export function marcarResposta(idProfissional, modulo) {
  marcar(idProfissional, 'resp:' + modulo, DIAS_MESMO_MODULO)
  marcar(idProfissional, 'geral', DIAS_ENTRE_PESQUISAS)
}

export function marcarDispensa(idProfissional, modulo) {
  marcar(idProfissional, 'dispensa:' + modulo, DIAS_APOS_DISPENSA)
  // Chave própria (`adiado`), e não `geral`: escrever `geral` com 15 dias
  // encurtaria a janela de 30 de quem tinha acabado de RESPONDER.
  marcar(idProfissional, 'adiado', DIAS_APOS_DISPENSA)
}

/** Usado só por teste — o produto nunca limpa a trava. */
export function limpar(idProfissional, modulo) {
  try {
    globalThis.localStorage.removeItem(chave(idProfissional, 'geral'))
    globalThis.localStorage.removeItem(chave(idProfissional, 'adiado'))
    globalThis.localStorage.removeItem(chave(idProfissional, 'resp:' + modulo))
    globalThis.localStorage.removeItem(
      chave(idProfissional, 'dispensa:' + modulo)
    )
  } catch (error_) {
    // Sem localStorage não há marca para remover.
    // eslint-disable-next-line no-console
    console.warn(
      '[nps] localStorage indisponível ao limpar:',
      error_ && error_.message
    )
  }
}
